import type { StoreLicense } from '@app/stores'
import { action } from 'mobx'

/**
 * Toggle ribbon visibility.
 */
export const handleWidgetRibbonVisibilityOnClick = (
  storeLicense: StoreLicense,
  isVisible: boolean
) =>
  action(() => {
    storeLicense.setRibbonVisibility(isVisible)
  })

/**
 * Show the hidden ribbon every x times.
 */
export const handleAppRibbonTimer = (
  storeLicense: StoreLicense,
  ribbonTimer: number
) =>
  action(() => {
    if (storeLicense.isRibbonVisible) {
      return
    }

    const timeoutId = setTimeout(
      () => storeLicense.setRibbonVisibility(true),
      ribbonTimer
    )

    return () => clearTimeout(timeoutId)
  })
